import { render, staticRenderFns } from "./MutateOwnerReportModal.vue?vue&type=template&id=312a30b8"
import script from "./MutateOwnerReportModal.vue?vue&type=script&lang=ts"
export * from "./MutateOwnerReportModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZBreadcrumbItem: require('/build/apps/legacy/components/zeal/ZBreadcrumb/ZBreadcrumbItem/ZBreadcrumbItem.vue').default,ZBreadcrumb: require('/build/apps/legacy/components/zeal/ZBreadcrumb/ZBreadcrumb.vue').default,ZInput: require('/build/apps/legacy/components/zeal/ZInput/ZInput.vue').default,CopyButton: require('/build/apps/legacy/components/CopyButton.vue').default,ZButton: require('/build/apps/legacy/components/zeal/ZButton/ZButton.vue').default,ToggleInput: require('/build/apps/legacy/components/Form/ToggleInput.vue').default,ZCheckbox: require('/build/apps/legacy/components/zeal/ZCheckbox/ZCheckbox.vue').default,ZRadio: require('/build/apps/legacy/components/zeal/ZRadio/ZRadio.vue').default,ZRadioGroup: require('/build/apps/legacy/components/zeal/ZRadioGroup/ZRadioGroup.vue').default,SelectRepositoriesForReport: require('/build/apps/legacy/components/Reports/SelectRepositoriesForReport.vue').default,ZModal: require('/build/apps/legacy/components/zeal/ZModal/ZModal.vue').default})
